
import { makeStyles } from '@mui/styles'

const styles = makeStyles(theme => ({
  pendingPatient: {
    borderRadius: "20px !important",
    margin: "5px !important",
    textTransform: "lowercase!important"
  },
  showMore: {
    position: "absolute",
    zIndex: "2",
    display: "flex",
    backgroundColor: "#FFFFFF",
    width: "84.8%",
  },
  pendingPatientType: {
    color: "#000000 !important",
    borderRadius: "20px !important",
    margin: "10px !important",
    textTransform: "lowercase!important"
  },
  subTitle: {
    borderBottom: "1px solid " + theme.palette.divider,
    paddingBottom: theme.spacing(.5),
    marginBottom: theme.spacing(2),
    "& .MuiTypography-root": {
      color: theme.palette.text.primary
    }
  },
  hintMessage: {
    fontSize: theme.typography.fontSize,
    color: theme.palette.warning.dark,
    marginLeft: theme.spacing(1),
  },
}));
export default styles;